export const SIMPLR = 'SIMPLR';
export const SIMPLR_BOT = 'SIMPLR_BOT';
export const SMB = 'SMB';
export const SMB_BOT = 'SMB_BOT';
export const CUSTOMER = 'CUSTOMER';
